(function () {
  function filterGallery(gallery, variantOptions) {
    var allValues = new Set(
      (gallery.dataset.allOptionValues || '').split(',').map(function (v) { return v.trim(); }).filter(Boolean)
    );
    var currentValues = new Set(
      variantOptions.map(function (v) { return v.toLowerCase().trim(); })
    );

    function applyFilter(slide) {
      var alt = (slide.dataset.variantOption || '').trim();
      var isVariantSpecific = alt !== '' && allValues.has(alt);
      var matchesCurrent = isVariantSpecific && currentValues.has(alt);
      if (!isVariantSpecific || matchesCurrent) {
        slide.classList.remove('cb-variant-hidden');
      } else {
        slide.classList.add('cb-variant-hidden');
      }
    }

    gallery.querySelectorAll('.product__media-list [data-variant-option]').forEach(applyFilter);
    gallery.querySelectorAll('.thumbnail-list [data-variant-option]').forEach(applyFilter);
  }

  document.querySelectorAll('media-gallery[data-all-option-values]').forEach(function (gallery) {
    var sectionId = gallery.id.replace('MediaGallery-', '');

    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event.data.sectionId !== sectionId) return;
      var variant = event.data.variant;
      if (!variant) return;
      filterGallery(gallery, variant.options || []);
    });
  });
})();
